import styled, { css } from 'styled-components';
import { WeSpinBadge } from '@comeon/ui';
import theme from 'styled-theming';

const BoostBadge = styled(WeSpinBadge)`
	background-color: var(--badge-dark-bg);
	color: var(--badge-dark-text);

	${theme('brand', {
		getlucky: css`
			background-color: var(--badge-secondary-bg);
			color: var(--badge-dark-text);
		`,
		nopeampi: css`
			background-color: var(--badge-secondary-bg);
			color: var(--badge-dark-text);
		`,
		casinostuen: css`
			background-color: var(--badge-secondary-bg);
			color: var(--badge-secondary-text);
		`
	})}
`;

export default BoostBadge;
